import React from 'react';
import { ChevronDown, Car, Zap } from 'lucide-react';
import { Button } from '../ui/button';
import { heroData } from '../../data/mock-v3';

const HeroV3 = () => {
  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gray-900">
      {/* Background Image - Ciudad tecnológica nocturna */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.image}
          alt="LUCARS Ciudad Tecnológica"
          className="w-full h-full object-cover opacity-80"
          style={{ filter: 'grayscale(50%) brightness(0.85)' }}
        />
        {/* Overlay oscuro sutil */}
        <div className="absolute inset-0 bg-gray-900/30"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 relative z-20">
        <div className="max-w-7xl mx-auto">
          {/* Logo LUCARS - DOBLE DE GRANDE con colores invertidos */}
          <div className="flex justify-center mb-8 lg:mb-12 animate-fadeIn">
            <div className="relative">
              {/* Logo - 2X MÁS GRANDE - Invertido para letras blancas, verde brillante #63E61E */}
              <img 
                src="https://customer-assets.emergentagent.com/job_responsive-design-68/artifacts/pi8nnphe_LUCARS_LOGO.png" 
                alt="LUCARS - Siempre en Movimiento" 
                className="relative h-[400px] sm:h-[600px] md:h-[800px] lg:h-[900px] xl:h-[1000px] w-auto object-contain drop-shadow-2xl"
                style={{ filter: 'invert(1) hue-rotate(180deg) saturate(3) brightness(1.15)' }}
              />
            </div>
          </div>

          {/* Description con estilo moderno - texto claro para fondo oscuro */}
          <div className="text-center mb-12">
            <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-white font-bold max-w-5xl mx-auto leading-tight drop-shadow-lg">
              {heroData.description}
            </p>
          </div>

          {/* Features Grid - 2 tarjetas minimalistas y modernas */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12">
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl transform transition-transform group-hover:scale-105 duration-300"></div>
              <div className="relative bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-10 border-4 border-gray-700 group-hover:border-[#63E61E] transition-all duration-300 shadow-2xl">
                <Car className="w-16 h-16 text-white mx-auto mb-6" />
                <h3 className="text-white font-black text-2xl mb-3 text-center">Autos a Gasolina</h3>
                <p className="text-gray-300 text-lg text-center">Vehículos confiables y eficientes para tu trabajo</p>
              </div>
            </div>
            
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#63E61E] to-[#52c518] rounded-3xl transform transition-transform group-hover:scale-105 duration-300"></div>
              <div className="relative bg-gradient-to-br from-[#63E61E] to-[#52c518] rounded-3xl p-10 border-4 border-[#52c518] group-hover:border-white transition-all duration-300 shadow-2xl">
                <Zap className="w-16 h-16 text-gray-900 mx-auto mb-6" />
                <h3 className="text-gray-900 font-black text-2xl mb-3 text-center">Autos Eléctricos</h3>
                <p className="text-gray-900 text-lg text-center">Tecnología limpia y sustentable del futuro</p>
              </div>
            </div>
          </div>

          {/* CTA Buttons con diseño impactante */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Button
              onClick={scrollToAbout}
              className="group bg-gradient-to-r from-[#63E61E] to-[#52c518] hover:from-[#52c518] hover:to-[#63E61E] text-gray-900 font-black text-xl px-12 py-8 rounded-full transition-all duration-300 shadow-2xl hover:shadow-[#63E61E]/50 hover:scale-110 border-4 border-gray-900"
            >
              <span>Conocer Más</span>
            </Button>
            <Button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gray-900 hover:bg-gray-800 text-white font-black text-xl px-12 py-8 rounded-full transition-all duration-300 shadow-2xl border-4 border-gray-900 hover:border-[#63E61E] hover:scale-110"
            >
              Contáctanos
            </Button>
          </div>
        </div>

        {/* Scroll Indicator animado */}
        <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2">
          <div className="flex flex-col items-center animate-bounce">
            <ChevronDown className="w-12 h-12 text-[#63E61E] mb-2" />
            <span className="text-white/80 font-semibold text-sm">Descubre más</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroV3;
